import { Controller } from 'react-hook-form';
import { Checkbox, Paragraph, Text } from '@beamery/lib-ds-components';
import { styled } from 'styled-components';
import type { DataProtectionFieldProps } from './compliance.interface';

const StyledCheckbox = styled(Checkbox)`
  & > span {
    white-space: unset;
    overflow: visible;
  }
`;

export const DataProtectionField = ({
  fieldName,
  fieldValidationRules,
  control,
  label,
}: DataProtectionFieldProps) => (
  <Controller
    control={control}
    name={fieldName}
    rules={fieldValidationRules.dataProtection}
    defaultValue={false}
    render={({
      field: { onChange, onBlur, value, ref, name },
      fieldState: { error },
    }) => (
      <>
        <StyledCheckbox
          label={
            <>
              {label}{' '}
              <Text aria-hidden color='error'>
                *
              </Text>
            </>
          }
          isRequired
          isSelected={value as boolean}
          onChange={onChange as (value: boolean) => void}
          onBlur={onBlur}
          ref={ref}
          name={name}
          isInvalid={!!error}
        />

        {error && (
          <Paragraph color='error' role='alert'>
            {error.message}
          </Paragraph>
        )}
      </>
    )}
  />
);
